import { ModelRow } from "@mcleod/core";
import { SecondaryFilterProps } from "@mcleod/dispatch";

const MOVE_STATUS_AVAILABLE = "A";
const MOVE_STATUS_IN_PROGRESS = "P";

export class PartialShipmentPlanningTaskFilter {

    public static readonly ORDERS_AVAILABLE: SecondaryFilterProps = {
        id: "availableOrders",
        caption: "Available",
        filter: (row: ModelRow) => {
            return row.get("move_status") == MOVE_STATUS_AVAILABLE;
        }
    }

    static readonly APPT_REQUIRED = {
        id: "apptRequired",
        caption: "Appointment Required",
        filter: (row: ModelRow): boolean => {
            return row.get("order_appointment_required") === true;
        }
    };

    static readonly APPT_CONFIRMED = {
        id: "apptConfirmed",
        caption: "Appointment Confirmed",
        filter: (row: ModelRow): boolean => {
            return row.get("order_appointment_confirmed") === true;
        }
    };

    public static readonly ORDERS_IN_PROGRESS: SecondaryFilterProps = {
        id: "inProgressOrders",
        caption: "In Progress",
        filter: (row: ModelRow) => {
            return row.get("move_status") == MOVE_STATUS_IN_PROGRESS;
        }
    }

    public static readonly ORDERS_TRUCKLOAD: SecondaryFilterProps = {
        id: "ordersMode",
        caption: "Truckload",
        filter: (row: ModelRow) => {
            return row.get("is_order_truckload");
        },
    }

    public static readonly Y_SPLIT_ORDERS_MOVEMENT: SecondaryFilterProps = {
        id: "ordersYSplit",
        caption: "Y-Split",
        filter: (row: ModelRow) => {
            const originStopType = row.get("origin_stop_type", "");
            const destStopType = row.get("destination_stop_type", "");
            return originStopType === "SP" || destStopType === "SD"
        },
    }

    public static readonly ORDERS_ASSET: SecondaryFilterProps = {
        id: "assetOrders",
        caption: "Asset",
        filter: (row: ModelRow) => {
            return row.get("brokerage") === false;
        }
    }

    public static readonly ORDERS_BROKERAGE: SecondaryFilterProps = {
        id: "brokerageOrders",
        caption: "Brokerage",
        filter: (row: ModelRow) => {
            return row.get("brokerage") === true;
        }
    }

    public static readonly MANIFESTS_SHELL: SecondaryFilterProps = {
        id: "shellManifests",
        caption: "Shell",
        filter: (row: ModelRow) => {
            return row.get("is_shell_manifests") === true;
        }
    }

    public static readonly MANIFESTS_IN_PROGRESS: SecondaryFilterProps = {
        id: "progressManifests",
        caption: "In Progress",
        filter: (row: ModelRow) => {
            return row.get("is_progress_manifests") === true;
        }
    }

    public static readonly MANIFESTS_Y_SPLIT: SecondaryFilterProps = {
        id: "ySplitManifests",
        caption: "Y-Split",
        filter: (row: ModelRow) => {
            return row.get("is_y_split_manifests") === true;
        }
    }

    public static readonly MANIFESTS_ON_HOLD: SecondaryFilterProps = {
        id: "manifestOnHold",
        caption: "Hold",
        filter: (row: ModelRow) => {
            return row.get("manifest_hold") === true;
        }
    }

    public static readonly MANIFESTS_ASSET: SecondaryFilterProps = {
        id: "assetManifests",
        caption: "Asset",
        filter: (row: ModelRow) => {
            return row.get("brokerage") === false;
        }
    }

    public static readonly MANIFESTS_BROKERAGE: SecondaryFilterProps = {
        id: "brokeragManifests",
        caption: "Brokerage",
        filter: (row: ModelRow) => {
            return row.get("brokerage") === true;
        }
    }
}
